import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  Stack,
  Fade,
} from '@mui/material'
import localization from '../utils/localization'

function ModalAlert(props) {
  return (
    <Dialog
      open={props.open}
      onClose={props.onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '28px',
          p: 1,
          overflow: 'visible',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 800,
          textAlign: 'center',
          pt: 4,
          pb: 1,
          color: '#1E293B',
        }}
      >
        {props.title || localization.strings.alertDialog}
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 4 }}>
        <Fade in={props.open} timeout={500}>
          <Box sx={{ mt: 1, textAlign: 'center' }}>
            {/* Warning Icon */}
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: '20px',
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                color: '#EF4444',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 3,
              }}
            >
              <i className="iconfont icon-delete" style={{ fontSize: '2rem' }}></i>
            </Box>

            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                color: '#1E293B',
                mb: props.hint ? 1.5 : 4,
                lineHeight: 1.6,
              }}
            >
              {props.content}
            </Typography>

            {props.hint && (
              <Typography
                variant="body2"
                sx={{
                  color: '#64748B',
                  mb: 4,
                  px: 2,
                  lineHeight: 1.5,
                }}
              >
                {props.hint}
              </Typography>
            )}

            <Stack direction="row" spacing={2}>
              <Button
                fullWidth
                variant="text"
                onClick={props.onCancel}
                sx={{
                  borderRadius: '14px',
                  py: 1.5,
                  fontWeight: 700,
                  color: '#64748B',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.03)' },
                }}
              >
                {localization.strings.cancel}
              </Button>
              <Button
                fullWidth
                variant="contained"
                onClick={props.onConfirm}
                sx={{
                  borderRadius: '14px',
                  py: 1.5,
                  fontWeight: 700,
                  backgroundColor: '#EF4444',
                  boxShadow: '0 8px 20px rgba(239, 68, 68, 0.2)',
                  textTransform: 'none',
                  '&:hover': {
                    backgroundColor: '#DC2626',
                    boxShadow: '0 12px 24px rgba(239, 68, 68, 0.3)',
                  },
                }}
              >
                {localization.strings.confirm}
              </Button>
            </Stack>
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  )
}

export default ModalAlert
